import React from "react";

// --- CSS --- //
import "../../styles/contact.css";

// --- ASSETS --- //
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';

const Contact = () => {
    return (
        <div className="contact-page">
            <div className="contact-window">
                <h1 className="contact-title">Contact Us</h1>
                <p className="contact-detail">
                    Have questions, feedback, or need assistance? We're here to help! Whether you're a climber, a gym owner, or just curious about VERT CERT, we'd love to hear from you.</p>
                <div className="contact-action-container">
                    <a href="tel:9705015156">
                        <button className="contact-action-button">
                            <PhoneIcon style={{ marginRight: "10px" }} />
                            Call
                        </button>
                    </a>
                    <a href="mailto:info@vertcertapp.com">
                        <button className="contact-action-button">
                            <EmailIcon style={{ marginRight: "10px" }} />
                            Email
                        </button>
                    </a>
                    <a href="https://www.google.com/maps/place/361+S+Camino+Del+Rio,+Durango,+CO+81303/">
                        <button className="contact-action-button">
                            <PlaceIcon style={{ marginRight: "10px" }} />
                            Location
                        </button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Contact;